export const ugovor_o_izvodenju_radova = {
    templateId: 55,
    category: 16,
    templateTitle: "Ugovor o izvođenju radova",
    templateDescription: `<p>Ugovorom o izvođenju radova izvođač obavlja manje i jednostavnije radove odnosno manje složene radove (u odnosu na ugovor o građenju) te se zbog toga u pravnom smislu takav ugovor smatra ugovorom o djelu.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Uvodno treba napomenuti da je ugovor o izvođenju radova ugovor kojim se izvođač za naknadu obvezao izraditi objekt koji se ne smatra građevinom i to postupkom koji podrazumijeva manje, jednostavnije ili manje složene radove odnosno ugovor kojim izvođač za naručitelja obavlja radove koji se ne mogu smatrati predmetom ugovora o građenju.</p>
    <p>Pod »građevinom« se smatraju zgrade, brane, mostovi, tuneli, vodovodi, kanalizacije, ceste, željezničke pruge, bunari i ostale građevine čija izrada zahtijeva veće i složenije radove.    </p>
    <p>Ipak, u svakom pojedinom slučaju (sporu) će se utvrđivati radi li se o manjim i jednostavnijim radovima te koje okolnosti još treba utvrditi da bi se moglo smatrati da se radi o ugovoru o izvođenju radova.    </p>
    <p>Sudskom praksom utvrđeni manji građevinski radovi su koji su predmet ugovora o izvođenju radova:</p>
    <li> uređenja pješačke staze i kolnog ulaza,</li>
    <li> izrada i montaža PVC stolarije,    </li>
    <li> otklanjanje određenih nedostataka nastalih zbog neurednog ispunjenja ranijeg ugovora o građenju od strane izvođača i sl..    </li>
    <br>
    <p>S druge strane, sudskom praksom utvrđeni predmet ugovora o građenju mogu biti npr.: izvođenje radova na instalacijama vodovoda i odvodnje na izgradnji poslovne građevine. </p>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o obveznim odnosima.</p>    
    `,

    sides: [
        {
            prefix: 'Na temelju odredaba Zakona o obveznim odnosima,',
            signature: 'Naručitelj:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: 'Posl. subjekt / Ime i prezime',        
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa (za pr. osobe)",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija (za pr. osobe)",
                inSignature: true,
              }],
            suffix: ' (u daljnjem tekstu: Naručitelj)',
            delimiter: `i`
        },
        {
            signature: 'Izvođač:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: 'Posl. subjekt / Ime i prezime',        
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa (za pr. osobe)",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija (za pr. osobe)",
                inSignature: true,
              }],
            suffix: ' (u daljnjem tekstu: Izvođač),'
        }
    ],

    headline: 'zaključuju sljedeći',
    title: 'UGOVOR O IZVOĐENJU RADOVA',
    noArticleNumbers: false,

    articles: [

        {
            title: 'UVODNE ODREDBE',
            mandatory: true,
            exampleContent: true,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Ugovorne strane sklapaju ovaj Ugovor prema prihvaćenoj ponudi Izvođača ____________, koja je sastavni dio ovog Ugovora. \r\nPonudom je uključen sav potreban rad, materijal, alat i sredstva za rad, pomoćni materijal za potrebnu zaštitu, čišćenje i zbrinjavanje otpadnog materijala proisteklog iz radova, troškovi prijevoza, kao i sve ostalo što je potrebno za izvršenje radova po ovom Ugovoru do potpune gotovosti.',
                    value: '',
                }],
        },
        {
            title: 'PREDMET UGOVORA',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Ovim Ugovorom Naručitelj naručuje, a Izvođač nabavlja, izrađuje i montira svu potrebnu opremu i materijal za izvođenje radova, a sve prema priloženoj i prihvaćenoj ponudi, koja je sastavni dio ovog Ugovora. ',
                    value: '',
                }],
        },
        {
            title: 'IZVOĐENJE RADOVA',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Izvođač će izvesti ugovorene radove u skladu s ovim Ugovorom, važećim tehničkim propisima i standardima, normativima i pravilima struke.\r\nUgovoreni rok za izvršenja radova može se produžiti samo u slučaju nastanka više sile ili sporazumno u pisanom obliku. \r\nIzvođač je dužan: \r\na) u tijeku rada, kao i po završetku radova, radno mjesto predati uredno i očišćeno od otpadaka i drugog neupotrebljivog materijala kojeg je dužan deponirati na za to određena mjesta o svom trošku,	 \r\nb) osigurati čuvanje svojih radova od oštećenja i otuđivanja sve do konačne primopredaje, kao i voditi računa da svojim radovima ne ošteti imovinu Naručitelja, \r\nc) za svoje radove osigurati propisane mjere zaštite na radu po svim postojećim propisima kao i pri radu čuvati sve uređaje Naručitelja i u tom pogledu snositi svu odgovornost, \r\nd) imenovati ovlaštenog predstavnika koji će zastupati Izvođača na mjestu izvođenja radova, \r\ne) za svoje radnike snositi troškove smještaja, prehrane i prijevoza. ',
                    value: '',
                }],
        },
        {
            title: 'CIJENA',
            mandatory: true,
            examplecontent: true,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Za ugovorene poslove iz ovog Ugovora ugovorne strane suglasno utvrđuju cijenu u iznosu od ______________,  a sve prema opisu, količinama i jediničnim cijenama navedenim u priloženoj i prihvaćenoj ponudi.\r\nUgovorne strane suglasne su da je cijena po ovom ugovoru fiksna i nepromjenjiva te da sadrži kompletne troškove opreme, izvođenja, materijala, alata i sredstava za rad, montaže, prijevoza, carina i svih ostalih davanja u vezi s izvršenjem ugovornih obveza.',
                    value: '',
                }],
        },
        {
            title: 'PLAĆANJE',
            mandatory: false,
            editable: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    parts: [
                        {type: 'text', content: 'Plaćanje iznosa iz ovog Ugovora će Naručitelj se obvezuje izvršiti'},
                        {type: 'textarea', value: '', required: true,},
                      ],
                }],
            value: '',
        },
        {
            title: 'POČETAK RADOVA',
            mandatory: false,
            editable: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    parts: [
                        {type: 'text', content: 'Izvođenje radova po ovom Ugovoru Izvođač je dužan započeti'},
                        {type: 'textarea', value: '', required: true,},
                      ],
                }],
            value: '',
        },
        {
            title: 'ZAVRŠETAK RADOVA',
            mandatory: true,
            editable: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    parts: [
                        {type: 'text', content: 'Izvođenje radova po ovom Ugovoru Izvođač je dužan završiti  '},
                        {type: 'textarea', value: '', required: true,},
                      ],
                }],
            value: '',
        },
        {
            title: 'PRIMOPREDAJA I PREUZIMANJE RADOVA',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Nakon što Izvođač izvrši sve radove koji su predmet ovog Ugovora, ugovorne strane će sastaviti zapisnik po kojemu će se obaviti primopredaja radova.\r\nPrimopredaja izvedenih radova po ovom Ugovoru izvršiti će se odmah po završetka radova i otklanjanja eventualnih nedostataka i/ili primjedbi (mjerodavan je događaj koji nastupi kasnije).',
                    value: '',
                }],
        },
        {
            title: 'UGOVORNA KAZNA',
            mandatory: false,
            examplecontent: true,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Izvođač se obvezuje za svaki dan prekoračenja roka završetka radova iz ovog Ugovora platiti Naručitelju na ime ugovorene kazne 2 ‰ (promila) od ugovorene cijene, s tim da ugovorena kazna ne može prijeći 5 % (posto) navedene cijene.',
                    value: '',
                }],
        },
        {
            title: 'JAMSTVO ZA UREDNO IZVRŠENJE',
            mandatory: false,
            examplecontent: true,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Izvođač jamči za kvalitetu izvedenih radova u trajanju od 2 godine (slovima: dvije godine).\r\nJamstveni rok počinje teći od dana uspješno obavljene primopredaje. ',
                    value: '',
                }],
        },
        {
            title: 'PRIDRŽAVANJE PROPISA IZ ZAKONA O ZAŠTITA NA RADU, NAKNADA ŠTETE',
            mandatory: false,
            examplecontent: true,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Izvođač preuzima odgovornost u vezi pridržavanja i poštivanja propisa iz područja Zakona o zaštiti na radu.\r\nU slučaju štetnog događaja proisteklog iz nepoštivanja zakonskih propisa od strane Izvođača radova, a koji događaj pričini štetu Naručitelju, Naručitelj ima pravo naknade takve štete od Izvođača.',
                    value: '',
                }],
        },
        {
            title: 'ODSTUPANJE OD UGOVORENIH UVJETA',
            mandatory: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: false,
                    parts: [
                        {type: 'text', content: 'Ako se tijekom obavljanja poslova utvrdi da se Izvođač ne drži obveza iz ovog Ugovora, Naručitelj može upozoriti Izvođača ​i odrediti mu primjeran rok da svoj rad uskladi sa svojim obvezama. Ako do isteka roka Izvođač ne postupi po zahtjevu Naručitelja, Naručitelj može raskinuti Ugovor u pisanom obliku uz otkazni rok od'},
                        {type: 'input', value: '', required: true},
                        {type: 'text', content: 'dana i zahtijevati naknadu štete.'}],
                }],
        },
        {
            title: 'RASKID UGOVORA PRIJE ROKA',
            mandatory: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: false,
                    parts: [
                        {type: 'text', content: 'Izvršenje ovog Ugovora o roku predstavlja bitan sastojak ovog Ugovora. \r\nUkoliko je Izvođač u zakašnjenju sa započinjanjem ili završetkom posla te je očito da ga neće završiti u roku, Naručitelj može raskinuti ugovor u pisanom obliku uz otkazni rok od'},
                        {type: 'input', value: '', required: true},
                        {type: 'text', content: 'dana i zahtijevati naknadu štete.'}],
                }],
        },
        {
            title: 'OTKAZ UGOVORA',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Naručitelj je ovlašten u bilo koje vrijeme otkazati ovaj Ugovor, pisanim putem, uz otkazni rok od 7 (sedam) dana.',
                    value: '',
                }],
        },
        {
            title: 'DOSTAVA',
            mandatory: false,
            exampleContent: true,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: 'U slučaju otkaza i raskida Ugovora, isti se mora drugoj ugovornoj strani dostaviti preporučenom pošiljkom putem pošte na adresu označenu u ovom Ugovoru ili na drugi pouzdan način.\r\nU slučaju nemogućnosti uredne osobne dostave pisane opomene i dostave otkaza zbog promjene adrese, odbijanja preuzimanja pismena ili drugih načina izbjegavanja primanja pismena, dostava se smatra uredno izvršenom danom predaje preporučene pošiljke pošti, bez obzira na to je li pošta bila u mogućnosti uručiti pisanu opomenu, odnosno otkaz ili drugo pismeno.  ',
                    value: '',
                },
            ],
            value: '',
        }, 
        {
            title: 'NADLEŽNOST',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom za Naručitelja.'
                                }
                            ]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom za Izvođača.'
                                }
                            ]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom u'
                                },
                                {type: 'input', value: '',help: "Upišite mjesno nadležni sud. Npr. ...sudom u Zagrebu; ...sudom u Splitu i sl..", required: true},
                        ]
                        }
                    ],
                    value: '',
                }
            ]
        },
        {
            title: 'MJERODAVNO PRAVO',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: false,
                    content: 'Na prava i obveze ugovornih stranaka, koja nisu uređena ovim Ugovorom, primjenjuju se odredbe Zakona o obveznim odnosima koje se odnose na ugovor o djelu.',
                    value: '',
                }],
        },
        {
            title: 'PRIMJENA UGOVORA',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Ovaj Ugovor se primjenjuje od trenutka potpisa ugovornih strana.',
                    value: '',
                }],
        },
        {
            title: 'PRIMJERCI UGOVORA',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Ovaj Ugovor sastavljen je u 2 (dva) primjerka, od kojih svaka ugovorna strana zadržava po 1 (jedan) primjerak.',
                    value: '',
                }],
          },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                  {
                    type: "text",
                    content: "U"
                  },
                  {
                    type: "input",
                    value: "",
                    placeholder: "Upišite mjesto.",
                    required: true,
                  },
                  {
                    type: "text",
                    content: ", dana"
                  },
                  {
                    type: "date",
                    value: new Date(),
                    required: true
                  },
                  {
                    type: "text",
                    content: "godine."
                  }
                ]
              },
            ]
          },
          {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
          }
        ],
      };


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/55_ugovor_o_izvodenju_radova.ts